import { quickLinks } from '@/mocks/categories';

export default function QuickLinks() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            常用网址快捷入口
          </h2>
          <span className="text-xs text-foreground-400 mt-1">网址导航123</span>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
          {quickLinks.map((link) => {
            const colorMap: Record<string, string> = {
              primary: 'bg-primary-50 text-primary-600 border-primary-200 hover:bg-primary-100 hover:border-primary-300',
              accent: 'bg-accent-50 text-accent-600 border-accent-200 hover:bg-accent-100 hover:border-accent-300',
              secondary: 'bg-secondary-50 text-secondary-600 border-secondary-200 hover:bg-secondary-100 hover:border-secondary-300',
            };
            return (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className={`flex flex-col items-center justify-center gap-2 p-4 rounded-xl border transition-all cursor-pointer ${colorMap[link.color] || colorMap.primary}`}
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                  <i className={`${link.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium whitespace-nowrap">{link.name}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}